import React, { useLayoutEffect } from "react";

import { Tab } from "@headlessui/react";
import PropTypes from "prop-types";

import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import TabListNew from "components/molecules/TabListNew/index";
import Banner from "components/organisms/Banner";
import ContactUs from "components/organisms/ContactUs";

import ContactUsPrivacyPolicy from "./ContactUsPrivacyPolicy";

const LegalDocuments = ({ data }) => {
  const getId = (id) => {
    return id
      .replace(/[^a-zA-Z ]/g, " ")
      .replace(/\s+/g, " ")
      .toLowerCase()
      .split(" ")
      .join("-");
  };

  useLayoutEffect(() => {
    if (window.location.hash) {
      setTimeout(() => {
        const id = window.location.hash.replace("#", "");
        const scrollToTable = document
          .getElementById(id)
          .getBoundingClientRect();

        window.scrollTo({
          top: scrollToTable.top + window.pageYOffset - 86,
          behavior: "smooth",
        });
      }, 100);
    }
  }, []);
  const scrollToSection = (event, id) => {
    event?.preventDefault();
    const scrollToTable = document.getElementById(id).getBoundingClientRect();

    window.scrollTo({
      top: scrollToTable.top + window.pageYOffset - 86,
      behavior: "smooth",
    });
    if (history.pushState) {
      history.pushState(null, null, `#${id}`);
    }
  };

  return (
    <>
      <section>
        <Banner
          minHeightBanner="banner-fix-min-h-569"
          title={data?.banner?.title}
          bgColor="bg-bbc-terms-policy"
          breadcrumbs={data?.banner?.breadcrumbs}
          leftClassName="relative lg:mt-0 col-12 lg:col-7"
          rightClassName="col-12 lg:col-5"
          rightContent={
            <Img
              src={data?.banner?.image?.src}
              width={data?.banner?.image?.width}
              height={data?.banner?.image?.height}
              wrapper={{
                className: `${
                  data?.banner?.image?.classNameWrapper
                    ? data?.banner?.image?.classNameWrapper
                    : "bbc-banner-image-country xl:top-28"
                }`,
              }}
              className="w-full"
              alt="banner"
              priority={true}
            />
          }
        />
      </section>
      <section>
        <div className="container">
          {data?.dataContent?.firstSection && (
            <div
              className="text-lg font-medium"
              dangerouslySetInnerHTML={{
                __html: data?.dataContent?.firstSection,
              }}
            />
          )}
          {data?.dataContent?.description &&
            data?.dataContent?.description.map((item, index) => (
              <p key={index} className={index === 0 ? "" : "mt-6"}>
                {item.text}
              </p>
            ))}
          <div className="pt-10">
            <Title
              as="h3"
              text="TABLE OF CONTENTS"
              className="mb-6 text-bbc-30px font-semibold text-bbc-brand-800"
            />
            <ul className="ml-2">
              {data?.dataContent?.sectionContent.map((item, index) => (
                <li
                  key={index}
                  className="relative mb-2 pl-3 before:absolute before:top-2.5 before:left-0 before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-bbc-brand-500 before:content-['']"
                >
                  <a
                    onClick={(e) => {
                      scrollToSection(e, getId(item.title));
                    }}
                    href={`#${getId(item.title)}`}
                    className="font-medium text-bbc-brand-500 hover:text-[#05D4FE]"
                  >
                    {item.title}
                  </a>
                </li>
              ))}
              {data?.dataContent?.contactUs && (
                <li className="relative mb-2 pl-3 font-medium  text-bbc-brand-500 before:absolute before:top-2.5 before:left-0 before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-bbc-brand-500 before:content-['']">
                  <a
                    onClick={(e) => {
                      scrollToSection(e, "contact-us");
                    }}
                    href={"#contact-us"}
                    className="hover:text-[#05D4FE]"
                  >
                    Contact Us
                  </a>
                </li>
              )}
            </ul>
          </div>
          <div className="page-content">
            {data?.dataContent?.sectionContent.map((item, index) => (
              <React.Fragment key={index}>
                <Title
                  id={getId(item.title)}
                  as="h3"
                  text={`${index + 1}. ${item.title}`}
                  className="mb-6 mt-10 text-lg font-semibold text-bbc-brand-700"
                />
                {item?.content &&
                  item?.content.map((element, i) => (
                    <React.Fragment key={i}>
                      {element?.subTitle && (
                        <Title
                          text={element.subTitle}
                          as="h4"
                          className={
                            element.className
                              ? element.className
                              : "mt-6 mb-0 pl-0 text-base font-semibold leading-7 tracking-[0.4px] lg:mb-4 lg:pl-4"
                          }
                        />
                      )}
                      {element?.text && (
                        <div
                          key={i}
                          className={`${
                            element.className
                              ? element.className
                              : "mb-0 pl-0 lg:mb-6 lg:pl-4"
                          }`}
                          dangerouslySetInnerHTML={{ __html: element.text }}
                        />
                      )}
                      {element?.subText && (
                        <div
                          key={i}
                          className={`${
                            element.className
                              ? element.className
                              : "mb-6 pl-0 lg:pl-[30px]"
                          }`}
                          dangerouslySetInnerHTML={{ __html: element.subText }}
                        />
                      )}
                      {element?.subTextChild && (
                        <div
                          key={i}
                          className={`${
                            element.className
                              ? element.className
                              : "mb-6 pl-0 lg:pl-[45px]"
                          }`}
                          dangerouslySetInnerHTML={{
                            __html: element.subTextChild,
                          }}
                        />
                      )}
                    </React.Fragment>
                  ))}
                {item?.tabList && (
                  <TabListNew
                    data={item?.tabList}
                    tabClass={{ othersClass: "whitespace-nowrap" }}
                    tabListClass={{
                      display: "flex justify-start",
                      border: "border-0",
                      padding: "px-3",
                      length: "w-full",
                      othersClass: "mb-6 overflow-auto",
                    }}
                  >
                    <Tab.Panels>
                      {item?.tabList.map((element, i) => (
                        <Tab.Panel
                          className="focus:outline-none focus:outline-0 focus:ring-0"
                          as="div"
                          key={i}
                        >
                          {element?.content.map((e, number) => (
                            <p
                              key={number}
                              className="mb-6 ml-0 lg:ml-10"
                              dangerouslySetInnerHTML={{ __html: e.text }}
                            />
                          ))}
                        </Tab.Panel>
                      ))}
                    </Tab.Panels>
                  </TabListNew>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      {data.dataContent?.dataContactUs ? (
        <ContactUsPrivacyPolicy
          dataContactUs={data.dataContent?.dataContactUs}
        />
      ) : (
        data?.dataContent?.contactUs && (
          <ContactUs isRefundPolicy={data?.dataContent?.isRefundPolicy} />
        )
      )}

      <span className="top-28 hidden"></span>
    </>
  );
};

export default LegalDocuments;

LegalDocuments.propTypes = {
  data: PropTypes.object,
};

LegalDocuments.defaultProps = {
  data: {},
};
